import { useEffect, useLayoutEffect, useRef, useState } from 'react';

export const useResizeObserver = <T extends HTMLElement>() => {
  const effect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const ref = useRef<T>(null);

  effect(() => {
    const element = ref.current;
    if (!element) return;

    const resizeObserver = new ResizeObserver(() => {
      setDimensions({
        width: element.offsetWidth,
        height: element.offsetHeight,
      });
    });

    resizeObserver.observe(element);
    return () => resizeObserver.unobserve(element);
  }, []);

  return { ref, dimensions };
};
